<template>
  <el-select style="width: 150px" v-model="selectedValue">
    <el-option v-for="item in dimensions" :key="item.value" :label="item.label" :value="item.value">
      <div class="option-item">
        <span class="check-icon" :class="{ 'el-icon-check': value === item.value }"></span>
        <div>
          <p class="label">{{ item.label }}</p>
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </el-option>
  </el-select>
</template>

<script setup>
import { computed } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Number,
    default: 0
  }
})
// eslint-disable-next-line
const emit = defineEmits(['input', 'change'])
const selectedValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('input', value)
    emit('change', value)
  }
})

const dimensions = [
  {
    value: 0,
    label: '包体统计数据维度',
    desc: '以单包维度进行所有指标的统计，如果一个用户玩多个包，会算多个包的激活、创角、留存等'
  },
  {
    value: 1,
    label: '中间件数据维度',
    desc: '同一个用户玩多个包，在同一个中间件维度下，只会算一次激活、创角、留存等'
  }
]
</script>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: 80px;
  width: 320px !important;
  border-bottom: 1px solid #efefef;

  .option-item {
    display: flex;

    .check-icon {
      width: 40px;
      position: relative;
      top: 10px;
      font-weight: 700;
    }
    .label {
      font-size: 14px;
      font-weight: 700;
    }
    .desc {
      white-space: normal;
      line-height: 20px;
      color: #8492a6;
      font-size: 12px;
    }
  }
}
</style>
